export default __webpack_public_path__ + "static/media/footer-logo.df53c018.png";